import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import type { IAIReport } from '@model/aiReport';

import { apiClient } from '@services/apiClient';

export const actionItemInactiveReportsKey = (actionItemId: string | number) => [
  'actionItemInactiveReports',
  +actionItemId,
];
export const actionItemInactiveReportsFn = (
  queryKey: ReturnType<typeof actionItemInactiveReportsKey>,
  signal: AbortSignal | undefined,
) =>
  apiClient.get(`${APP_API_URL_V2}fsd/action-item/${queryKey[1]}/report/inactive`, {
    signal,
  });

const actionItemInactiveReportsSelect = ({ data }: AxiosResponse<{ data: { reports: IAIReport[] } }>) =>
  data?.data?.reports;

export const useActionItemInactiveReportsQuery = ({ actionItemId }: { actionItemId: string | number }) => {
  return useQuery({
    // @ts-ignore TODO: update react-query to v5
    queryKey: actionItemInactiveReportsKey(actionItemId),
    queryFn: ({ queryKey, signal }: QueryFunctionContext<ReturnType<typeof actionItemInactiveReportsKey>>) =>
      actionItemInactiveReportsFn(queryKey, signal),
    enabled: !!actionItemId && actionItemId !== 'onboarding',
    useErrorBoundary: true,
    cacheTime: 1000,
    select: actionItemInactiveReportsSelect,
    placeholderData: {
      data: {
        data: {
          reports: [],
        },
      },
    },
  });
};
